<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-solicitudes-inscripciones"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { cellRendererEstadoSolicitudInscripcion } from '../utils/funciones';

export default {
  name: 'ListadoSolicitudesInscripciones',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° SOLICITUD',
          field: 'numeroSolicitud',
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'FECHA SOLICITUD',
          field: 'fechaSolicitud',
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'NOMBRE SOLICITANTE',
          field: 'nombreSolicitante',
          minWidth: 300,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: cellRendererEstadoSolicitudInscripcion,
          valueGetter: (params) => {
            return params.data?.estado?.toUpperCase();
          },
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'N° ESTUDIANTES',
          cellRenderer: (params) => {
            return params.data?.detallesSolicitudesInscripciones?.length || 0;
          },
          type: 'numericColumn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'SEDE',
          field: 'sede.nombre',
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-solicitudes-inscripciones {
  height: calc(var(--vh, 1vh) * 100 - 24rem);
}
</style>
  